import { ShieldCheck, Zap, Scale } from "lucide-react";
import { Card } from "@/components/ui/card";
const coreValues = [{
  id: "integrity",
  title: "Integrity",
  description: "We operate with complete transparency. You will receive a fair cash offer with absolutely no hidden fees or surprise costs.",
  icon: "shield"
}, {
  id: "speed",
  title: "Speed",
  description: "We understand the urgency of selling your home. Our streamlined process allows us to close fast, often in as little as 7–14 days.",
  icon: "zap"
}, {
  id: "fairness",
  title: "Fairness",
  description: "We are dedicated to your satisfaction. We cover all closing costs and buy your house in any condition, saving you time and money.",
  icon: "scale"
}];
export default function OurCoreValues() {
  return <section id="our-core-values" className="py-24 bg-background">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-6">
            Our Core Values
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">At New Chapter Property Solutions, our foundation is built on principles that guarantee a smooth, trustworthy experience for every homeowner.</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {coreValues.map((item, i) => <Card key={item.id} data-index={i} className="bg-transparent border border-border hover:border-primary hover:shadow-xl hover:shadow-primary/15 transition-all duration-500 flex flex-col items-center text-center px-8 py-12 group">
              <div className="text-primary mb-6 transform group-hover:scale-110 transition-transform duration-500">
                {item.icon === "shield" && <ShieldCheck className="w-12 h-12" strokeWidth={1.5} />}
                {item.icon === "zap" && <Zap className="w-12 h-12" strokeWidth={1.5} />}
                {item.icon === "scale" && <Scale className="w-12 h-12" strokeWidth={1.5} />}
              </div>
              <h3 className="text-2xl font-bold mb-4 text-foreground">{item.title}</h3>
              <p className="text-base text-muted-foreground leading-relaxed">
                {item.description}
              </p>
            </Card>)}
        </div>
      </div>
    </section>;
}